import {
  BLUE,
  GRAY,
  GREEN,
  LIGHT_YELLOW,
  LOW_BLUE,
  ORANGE,
  RED,
} from "../config/colors";
import { Status, StatusTypes } from "../types/statusTypes";

export interface getRiskColorByNameProps {
  status?: "low" | "medium" | "high" | "noData";
  color?: string;
  statusCode?: Status;
}

export const statusCodeMapping = {
  [StatusTypes.critical]: RED,
  [StatusTypes.degraded]: ORANGE,
  [StatusTypes.healthy]: GREEN,
  [StatusTypes.mitigated]: LIGHT_YELLOW,
};

const getStatusColor = (
  value: getRiskColorByNameProps["color" | "status" | "statusCode"],
  mapping: Record<string, string>,
): string | undefined => {
  return mapping[value ?? ""];
};

export const getRiskColorByName = (
  status?: getRiskColorByNameProps["status"],
  color?: getRiskColorByNameProps["color"],
  statusCode?: getRiskColorByNameProps["statusCode"],
): string | undefined => {
  const statusMapping = {
    high: RED,
    medium: ORANGE,
    low: GREEN,
  };

  const colorMapping = {
    RED,
    ORANGE,
    GREEN,
    BLUE,
    LOW_BLUE,
    LIGHT_YELLOW,
  };

  return (
    getStatusColor(status, statusMapping) ||
    getStatusColor(color, colorMapping) ||
    getStatusColor(statusCode, statusCodeMapping) ||
    GRAY
  );
};
